/* eslint-disable no-restricted-globals */
import React, { Component } from 'react';
import radium, { Style } from 'radium';
import Relay from 'react-relay/classic';
import TextReviewCard from './ReviewCards/TextReviewCard';
import QuizReviewCard from './ReviewCards/QuizReviewCard';
import SliderReviewCard from './ReviewCards/SliderReviewCard';

class ReviewPeerQuestionItem extends Component {
  static styles = {};

  allInputs = [];

  clearAllInputs = () => {
    this.allInputs.forEach(input => input.clearInputValue && input.clearInputValue());
  };

  renderReviewCards(rootQ, index) {
    let reviewView = '';
    const rType = rootQ.rType;
    const options = rootQ.options;
    if (rType === 'text') {
      reviewView = (
        <TextReviewCard
          index={index}
          ref={ref => (this.allInputs[index] = ref)}
          getAllPeerQResponse={this.props.getAllPeerQResponse}
        />
      );
    } else if (rType === 'quiz') {
      reviewView = (
        <QuizReviewCard
          options={options}
          index={index}
          ref={ref => (this.allInputs[index] = ref)}
          maxScore={this.props.rootQ.maxScore}
          getAllPeerQResponse={this.props.getAllPeerQResponse}
        />
      );
    } else {
      reviewView = (
        <SliderReviewCard
          options={options}
          index={index}
          maxScore={this.props.rootQ.maxScore}
          ref={ref => (this.allInputs[index] = ref)}
          getAllPeerQResponse={this.props.getAllPeerQResponse}
        />
      );
    }
    return reviewView;
  }

  render() {
    const styles = ReviewPeerQuestionItem.styles;
    const rootQ = this.props.rootQ;
    const index = this.props.index;
    return (
      <div className="peerQuestionContainer">
        <div style={styles.questionMarksContainer}>
          <div style={styles.questionText}>
            {index + 1}
.
            {rootQ.question + (rootQ.rType !== 'text' ? ' *' : '')}
          </div>
          {!isNaN(this.props.rootQ.maxScore) && this.props.rootQ.maxScore > 0 ? (
            <div style={styles.questionMarks}>
(
              {this.props.rootQ.maxScore}
              {' '}
POINTS)
            </div>
          ) : null}
        </div>
        {this.renderReviewCards(rootQ, index)}
        <Style rules={styles.classBased} />
      </div>
    );
  }
}

ReviewPeerQuestionItem.styles = {
  classBased: {
    '.peerQuestionContainer': {
      marginBottom: '24px'
    },
    '.peerQuestionContainer:last-child': {
      marginBottom: '0px'
    },
    '.optionWrapper': {
      marginBottom: '10px'
    },
    '.optionWrapper:last-child': {
      marginBottom: '0px'
    }
  },
  displayFlexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  displayFlexColumn: {
    display: 'flex',
    flexDirection: 'column'
  },
  alignItemsCenter: {
    alignItems: 'center'
  },
  contentSpaceBetween: {
    justifyContent: 'space-between'
  },
  questionText: {
    fontSize: '14px',
    lineHeight: '16px',
    color: '#36465d',
    marginBottom: '12px'
  },
  questionMarks: {
    fontSize: '12px',
    color: '#758da1',
    fontWeight: '500'
  },
  questionMarksContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
};

export default Relay.createContainer(radium(ReviewPeerQuestionItem), {
  initialVariables: {
    userId: null
  },
  fragments: {
    rootQ: () => Relay.QL`
      fragment on ReviewQuestionType {
        question
        rType
        maxScore
        options {
          text
          correct
          relativeScore
        }
      }
    `
  }
});
